<template>
    <CardsSquare>
        <CardSquare
            :title="variant.label"
            @click="model = variant.value"
            v-for="variant in variants"
            :key="variant.value"
            :is-selected="variant.value === model"
        >
            <component class="w-6 h-6 ct-fg-4" :is="variant.icon" />
        </CardSquare>
    </CardsSquare>
</template>

<script>
import { CardSquare, CardsSquare } from "@easy/ui/cards";

export default {
    name: "cCreatorLayouts",
    props: {
        modelValue: String,
        variants: Array,
    },
    emits: ["update:modelValue"],
    components: {
        CardSquare,
        CardsSquare,
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
};
</script>
